import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Layout } from "antd";

import api from "./api";
import HeaderComponent from "./components/Header";
import Hero from "./components/Hero";
import Portfolio from "./components/Portfolio";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";

const { Header, Content } = Layout;

const HomePage = () => {
  const [sections, setSections] = useState({});
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const loadContent = async () => {
      try {
        const [sectionsResponse, projectsResponse] = await Promise.all([
          api.get("/sections/"),
          api.get("/projects/"),
        ]);
        setSections(
          sectionsResponse.data.reduce((acc, section) => {
            acc[section.key] = section;
            return acc;
          }, {})
        );
        setProjects(projectsResponse.data);
      } catch {
        console.warn("Using fallback page content because the API is unavailable.");
      }
    };

    loadContent();
  }, []);

  const scrollToPortfolio = () => {
    const portfolioSection = document.getElementById("portfolio");
    if (portfolioSection) {
      portfolioSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Hero content={sections.hero} onViewPortfolio={scrollToPortfolio} />
      <Portfolio projects={projects} />
      <Services content={sections.services} />
      <About content={sections.about} />
      <Contact content={sections.contact} />
    </>
  );
};

function App() {
  const [contactSection, setContactSection] = useState(null);

  useEffect(() => {
    const loadContactDetails = async () => {
      try {
        const response = await api.get("/sections/");
        setContactSection(
          response.data.find((section) => section.key === "contact") || null,
        );
      } catch {
        console.warn("Using fallback footer contact details because the API is unavailable.");
      }
    };

    loadContactDetails();
  }, []);

  return (
    <Router>
      <Layout style={{ minHeight: "100vh" }}>
        <Header style={{ background: "#fff", padding: 0 }}>
          <HeaderComponent />
        </Header>

        <Content className="page-content" style={{ padding: "0 50px", marginTop: 20 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </Content>

        <Footer contact={contactSection} />
      </Layout>
    </Router>
  );
}

export default App;
